﻿import { Duration, Moment } from 'moment';
import moment from 'moment';

export class NumberHelper {
    public static format(value: number, digits: number): string {
        return ('000000000' + value).slice(digits * -1);
    }
}

export class DurationHelper {
    public static toHoursAndMinutes(value: Duration): string {
        return `${NumberHelper.format(value.hours(), 2)}:${NumberHelper.format(value.minutes(), 2)}`;

    }

    public static toMoment(value: Duration): Moment {
        return  moment({ hours: value.hours(), minutes: value.minutes() });
    }
}
